import "./HeaderMultisite.scss";
import initNav from "shared/vanilla/nav";
initNav();